import { render, staticRenderFns } from "./dados-basicos.vue?vue&type=template&id=221e9c66"
import script from "./dados-basicos.vue?vue&type=script&lang=js"
export * from "./dados-basicos.vue?vue&type=script&lang=js"
import style0 from "./dados-basicos.vue?vue&type=style&index=0&id=221e9c66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports